<div class=" w-full flex items-center justify-center gap-2 text-foreground" style="height: calc(100vh - 66px)">
  <h1>404 | </h1>
  <p>{{ message() }}</p>
</div>
